<template>
    <div>
        <template
            v-for="(property, index) in properties_object"
        >
            <v-divider
                v-if="index !== 0"
                class="mx-4"
            ></v-divider>

            <summary-breakdown
                class="py-3 px-4"
                :object="benefits"
                :property="property"
                :key="'property-' + index"
                :small="small"
            ></summary-breakdown>
        </template>

        <v-divider></v-divider>

        <template
            v-for="(property, index) in properties"
        >
            <summary-value
                :key="index"
                class="py-3 px-4"
                :object="benefits"
                :property="property"
                :small="small"
                :greyed="isGreyed(property)"
                :inverted="isInverted(property)"
                :prependLabel="appendLabel(property)"
            ></summary-value>

            <v-divider></v-divider>
        </template>
    </div>
</template>

<script>
    import SummaryValue from "../../../Global/SummaryValue";
    import SummaryBreakdown from "../../../Global/SummaryBreakdown";

    import HomeVantageMixin from "../../homevantage";

    export default {
        name: 'HomeVantage-Summary-Upfront',

        components: {
            SummaryValue,
            SummaryBreakdown
        },

        mixins: [
            HomeVantageMixin
        ],

        props: {
            'mobile': {
                type: Boolean,
                default: false,
            },
            'small': {
                type: Boolean,
                default: false,
            }
        },

        data() {
            return {
                properties_object: [],
                properties: [
                    'totalRequiredDeposit',
                    'transferDuty',
                    'totalRegistrationCosts',
                    'totalUpfrontPayment',
                ],
            }
        },

        mounted() {
            // this.setPropertyObjects();
        },

        methods: {
            isGreyed(property) {
                return false;
            },
            isInverted(property) {
                return property === 'totalUpfrontPayment';
            },
            appendLabel(property) {
                if (property === 'transferDuty' && this.benefits.additionalBondForTransferDuty.value) {
                    return ' (incl. in bond)';
                }
                if (property === 'totalRegistrationCosts' && this.benefits.additionalBondForAttorneyFees.value) {
                    return ' (incl. in bond)';
                }
            }
        }
    }
</script>
